<template>
  <div>
    <section>
      <div class="inner row5">
        <div class="title mobileCenter">
          <h1>1:1 문의</h1>
        </div>
        <section>
          <div class="row4">
            <div class="aRow5">
              <div class="flex flexAlignS bdBttom mobileFlex">
                <div class="qnaInputBox">
                  <label>제목</label>
                  <input
                    ref="title"
                    v-model="saveData.title"
                    placeholder="제목을 작성해주세요."
                    maxlength="85"
                  />
                </div>
                <div class="detailInputBox flex flexAlignC">
                  <label class="mobileReset">첨부파일</label>
                  <div class="detailFileInputBox">
                    <SingleFileUpload
                      v-bind:saveData="saveData"
                      @set-file="setFile"
                    ></SingleFileUpload>
                  </div>
                </div>
              </div>
              <div class="qnaTxtBox">
                <textarea
                  v-model="saveData.content"
                  class="qnaTxtBoxItem"
                  placeholder="내용을 입력해주세요."
                ></textarea>
              </div>
            </div>

            <div class="btnBox">
              <button @click="listBtnGo()" class="redborderBtn">목 록</button>
              <button class="redBtn" @click="qnaSubmit">등 록</button>
            </div>
          </div>
        </section>
      </div>
    </section>
  </div>
</template>

<script>
import axios from "@/axios/axios";
import SingleFileUpload from "@/components/layout/board/SingleFileUpload";

export default {
  name: "QNAWirte",
  components: {
    SingleFileUpload,
  },
  data() {
    return {
      saveData: {
        title: "",
        content: "",
        file: null,
        fileGroupId: "",
        fileName: "",
      },
    };
  },
  methods: {
    listBtnGo() {
      this.$router.push("/QnA");
    },
    qnaSubmit() {
      let title = this.saveData.title;
      let content = this.saveData.content;
      let file = this.saveData.file;

      if (!title) {
        this.$alert("알림", "제목을 작성해주세요.");
        return false;
      }

      if (!content) {
        this.$alert("내용을 입력해주세요.");
        return false;
      }

      const formData = new FormData();
      formData.append("title", title);
      formData.append("content", content);
      formData.append("uploadFile", file);

      axios
        .post("/api/qna/submit", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((result) => {
          if (result.status == 200) {
            this.$alert("알림", "1:1 문의 등록되었습니다.", "", {
              closed: () => {
                this.$router.push({
                  name: "qNADetail",
                  params: { idx: result.data.IDX },
                });
              },
            });
          } else {
            this.$alert(
              "알림",
              "1:1 문의 등록에 실패하였습니다. 관리자에게 문의해주세요.",
            );
          }
        })
        .catch((error) => {
          this.$alert(
            "알림",
            "1:1 문의 등록에 실패하였습니다. 관리자에게 문의해주세요." +
              error.response.data.error,
          );
        });
    },
    setFile(file) {
      this.saveData.file = file;
    },
  },
};
</script>

<style scoped>
.bdBttom {
  border-bottom: 2px solid #272727;
  margin: 0 0 20px 0;
}
.qnaInputBox {
  padding: 0 0 14px 0;
}
.qnaInputBox label {
  font-size: 26px;
  line-height: 38px;
  color: #272727;
}
.qnaInputBox input {
  width: 300px;
  font-size: 26px;
  line-height: 38px;
  border: 0;
  outline: none;
  margin: 0 0 0 20px;
}
.qnaInputBox input:focus-visible {
  border: 0;
  outline-offset: 0;
  outline: none;
}
.qnaFileInputBox input[type="file"] {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}
.qnaFileInputBox label {
  display: inline-block;
  padding: 6px 20px 5px;
  color: #fff;
  font-size: inherit;
  line-height: normal;
  vertical-align: middle;
  background-color: #26336a;
  cursor: pointer;
  margin: 0 0 0 5px;
  font-size: 24px;
  line-height: 35px;
} /* named upload */
.qnaFileInputBox label:active {
  transform: scale(0.97);
}
.qnaFileInputBox .upload-name {
  display: inline-block;
  padding: 6px 20px 5px; /* label의 패딩값과 일치 */
  font-size: inherit;
  font-family: inherit;
  line-height: normal;
  vertical-align: middle;
  background-color: #f5f5f5;
  -webkit-appearance: none; /* 네이티브 외형 감추기 */
  -moz-appearance: none;
  appearance: none;
  font-size: 24px;
  line-height: 35px;
}
.qnaTxtBox {
  background: #fdfcfc;
  border: 1px solid #e7e7e7;
  padding: 20px 30px;
  margin: 0 0 10px 0;
}
.qnaTxtBoxItem {
  width: 100%;
  height: 460px;
  border: 0;
  background: #fdfcfc;
  font-size: 24px;
  line-height: 35px;
  color: #272727;
  resize: none;
  font-family: "NotoSans";
}
.qnaTxtBoxItem:focus-visible {
  border: 0;
  outline-offset: 0;
  outline: none;
}
.qnaTxtBoxItem + .qnaTxtBoxItem:focus-visible {
  border: 1px solid #26336a;
}
.btnBox {
  padding: 0;
  text-align: right;
}
.btnBox button:nth-of-type(2) {
  margin: 0 0 0 10px;
}
@media screen and (max-width: 560px) {
  .qnaInputBox {
    width: 100%;
    border-bottom: 1px solid #e7e7e7;
  }
  .qnaInputBox input {
    width: 100%;
    margin: 0;
    font-size: 20px;
    line-height: 29px;
  }
  .qnaInputBox label {
    margin: 0 0 16px 0;
    display: inline-block;
    font-weight: 500;
    font-size: 20px;
    line-height: 29px;
  }
  .detailInputBox {
    padding: 10px 0;
  }
  .btnBox {
    text-align: center;
  }
  .qnaTxtBox {
    padding: 10px;
  }
  .qnaTxtBoxItem {
    font-size: 20px;
    line-height: 29px;
  }
}
</style>
